import {AutocompleteService} from '@frontapp/editor-html';
import React, {PureComponent, ReactNode} from 'react';

import {ServiceSubscription} from '../serviceSubscription';
import {EmojiEditorDropdownContentContainer} from './emojiEditorDropdownContentContainer';

/*
 * Props.
 */

export interface EmojiEditorDropdownProps {
  autocompleteService: AutocompleteService;
}

/*
 * Component.
 */

export class EmojiEditorDropdown extends PureComponent<EmojiEditorDropdownProps> {
  render() {
    const {autocompleteService} = this.props;

    return (
      <ServiceSubscription source={autocompleteService}>
        {({textBeforeCursor}) => this.maybeRenderDropdown(textBeforeCursor)}
      </ServiceSubscription>
    );
  }

  private maybeRenderDropdown(textBeforeCursor: string): ReactNode {
    const {autocompleteService} = this.props;
    return (
      <EmojiEditorDropdownContentContainer
        textBeforeCursor={textBeforeCursor}
        getAnchor={(partialText) => autocompleteService.getBoundingClientRect(partialText)}
        onEmojiSelect={(partialShortcode, shortcode) => {
          autocompleteService.autocomplete(partialShortcode, shortcode);
        }}
      />
    );
  }
}
